var _path, _path2, _path3, _path4, _polygon, _path5, _path6, _polygon2, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _circle, _path24, _path25, _circle2, _path26, _path27, _path28, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _circle3, _path29, _polygon3, _path30, _path31, _path32, _path33, _polygon4, _path34, _path35, _circle4, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMovieNight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 844.67004,
    height: 331.55194,
    viewBox: "0 0 844.67004 331.55194",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M310.95318,485.0242a3.61324,3.61324,0,0,1-2.61866-6.26263c.09111-.36213.15647-.62217.24758-.9843a9.70742,9.70742,0,0,0-17.99686-.16973c-4.28226,10.02341-9.82453,20.4-7.06825,31.44012-18.206-38.58538-12.01459-86.582,14.89138-119.57968,7.43714-4.09683,13.46508-11.37558,15.03439-19.82719-3.6807,1.24714-8.26984-1.74674-5.50237-5.62381,1.19955-1.48179,2.41076-2.95193,3.6102-4.43381-13.98172-14.89038-30.6407,8.512-15.25087,28.60948a115.84727,115.84727,0,0,0-13.01133,20.35184,48.70923,48.70923,0,0,0-2.908-22.62446c-2.78346-6.7148-8.00064-12.37-12.595-18.175-5.58607-7.07308-17.083-3.80993-17.83469,5.16593,5.15526,1.69443,5.825,9.14116-.072,10.16037,1.54456,16.69794,12.45346,32.04321,27.47828,39.36634a116.29876,116.29876,0,0,0-6.35538,48.6114c-2.65207-19.25-23.31569-23.92147-37.7586-31.57247a5.626,5.626,0,0,0-8.5801,5.69852,32.49472,32.49472,0,0,1,5.69583,3.00488,4.91123,4.91123,0,0,1-2.28162,8.96546c7.28014,18.018,26.10227,30.11727,45.43371,30.04915a119.56321,119.56321,0,0,0,8.03167,23.447H310.2342c.10292-.3188.19543-.64791.288-.96672a32.59828,32.59828,0,0,1-7.93916-.473c7.02637-8.31908,12.46032-12.56336,8.371-24.1772Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M901.05356,485.0242a3.61324,3.61324,0,0,0,2.61866-6.26263c-.09111-.36213-.15647-.62217-.24758-.9843a9.70741,9.70741,0,0,1,17.99685-.16973c4.28227,10.02341,9.82454,20.4,7.06826,31.44012,18.206-38.58538,12.01458-86.582-14.89138-119.57968-7.43714-4.09683-13.46509-11.37558-15.0344-19.82719,3.6807,1.24714,8.26985-1.74674,5.50238-5.62381-1.19956-1.48179-2.41076-2.95193-3.6102-4.43381,13.98171-14.89038,30.64069,8.512,15.25086,28.60948a115.84674,115.84674,0,0,1,13.01134,20.35184,48.70923,48.70923,0,0,1,2.908-22.62446c2.78347-6.7148,8.00064-12.37,12.595-18.175,5.58608-7.07308,17.08305-3.80993,17.8347,5.16593-5.15526,1.69443-5.825,9.14116.072,10.16037-1.54455,16.69794-12.45345,32.04321-27.47828,39.36634a116.29892,116.29892,0,0,1,6.35539,48.6114c2.65207-19.25,23.31569-23.92147,37.75859-31.57247a5.626,5.626,0,0,1,8.58011,5.69852A32.49472,32.49472,0,0,0,981.648,448.18a4.91123,4.91123,0,0,0,2.28161,8.96546c-7.28014,18.018-26.10227,30.11727-45.43371,30.04915a119.5619,119.5619,0,0,1-8.03167,23.447H901.77253c-.10291-.3188-.19542-.64791-.288-.96672a32.59825,32.59825,0,0,0,7.93916-.473c-7.02636-8.31908-12.46031-12.56336-8.371-24.1772Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#f2f2f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M177.665,511.38735a1.18646,1.18646,0,0,0,1.19006,1.19h842.29a1.19,1.19,0,0,0,0-2.38H178.855A1.18651,1.18651,0,0,0,177.665,511.38735Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#ccc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M326.16977,494.86505c-.39916-5.84711-.40122-11.42877-.5157-15.73306-.23317-8.76634,18.67312-8.141,28.83921-8.41144l36.91285-1.74991c10.16609-.27039,18.62672,6.64173,18.85988,15.40807s-7.848,16.11843-18.01414,16.38883c-14.93228,12.96128-26.51447,13.59173-46.998,12.72533A19.98073,19.98073,0,0,1,326.16977,494.86505Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2f2e41"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "233.382 311.33 243.958 313.058 255.656 273.087 240.047 270.537 233.382 311.33",
    fill: "#ffb6b6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M415.24964,512.20687c-19.71875,4.84863-34.27918-.61171-46.27164.0963C362.1609,500.8,340.40029,486.189,352.27337,480.03883c6.61207-3.425,73.8284-11.32056,82.65232-2.20807,12.42427,12.83058,10.68862,36.168,6.57484,54.659q-.16467.74021-.33421,1.46977-.3127,1.34629-.639,2.65249c-.27372,1.09726-2.16621,1.07893-2.44855,2.12612-.39838,1.47755.81052,3.994.40853,5.35423-.68873,2.33046-2.77181,4.52125-2.00716,6.37721,2.10937,5.11865-2.2461,9.09815-3.40137,9.26856l-16-4c-1.12988-.26612-3.78125-3.07373.457-5.53907,1.2002-.69824.18674-2.98317.265-4.73509.0481-1.077.09051-2.21245.12368-3.39306.04408-1.569.07184-3.21783.075-4.91536C418.01485,528.78171,417.43093,519.22229,415.24964,512.20687Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M411.9733,580.7038l15.68259,3.21176L425.8851,590.529l11.96153,14.06476a4.27651,4.27651,0,0,1-4.36369,6.90188l-18.377-4.92059-1.416-7.38981-2.98836,6.21052-6.92887-1.85526Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "116.249 241.73 117.164 252.407 158.783 253.959 157.432 238.2 116.249 241.73",
    fill: "#ffb6b6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M395.16292,504.71156c-18.18917-6.6611-24.9902-22.89716-30.837-39.9355,9.48311-9.42683,22.53768-23.56084,31.40853-13.55569,4.94013,5.57183,44.25042,53.36133,37.57664,64.14835-10.26819,16.59675-43.77479,21.699-69.03479,23.12017q-2.317.13036-4.53432.22121-2.03628.08439-3.9704.13977c-5.21772.15148-10.71623-2.26849-13.41838.11627-4.86816,4.29688-8.11425,2.22461-8.27441-.228l-1-17c-.72852-2.73536,6.9375-5.02735,10-2,2.2002,2.17529,1.26125-.29729,7.03642-1.61319C364.0762,514.94386,383.38681,510.00417,395.16292,504.71156Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M308.539,523.21463l.72706,15.99157-6.84569-.09709-10.70675,15.042a4.27651,4.27651,0,0,1-7.76043-2.54037l.2698-19.02246,6.81794-3.18278-6.75328-1.37625.10172-7.17223Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M332.69147,483.71052a.501.501,0,0,1,.01575-.51891c-6.14236-.22753-12.23934,1.17851-10.62848-4.45349.23012-.80458,5.75817-6.68765,6.08045-7.56977.2797-.76559-1.41794-4.612-1.08045-5.43023.66132-1.60337,3.43217-.24953,4.254-2.02469.28918-.62458-1.55629-2.33283-1.254-2.97531.2843-.60434,2.71568-.14193,3.00852-.76059,5.50242-11.62475,12.25109-25.65051,10.4764-37.23642-2.249-14.68244-1.90687-35.51713-2.342-48.69331a11.7581,11.7581,0,0,1,8.506-11.67964c4.0127-1.16669,8.82366-3.22317,12.01672-6.78234.83533-.93132.93619.73852,1.04267-1.532.1301-2.76545.2647-5.62539,1.74115-7.10185l.06412-.06373.08585-.02925c6.21553-2.07034,16.71083-.7311,19.83134-.00975l.13535.0315.084.111c1.29012,1.70216,1.21889,4.42562,1.15028,7.0591-.06187,2.36954-.12035.79342.92981,1.46829q1.2187.784,2.34254,1.499c9.2378,5.89233,13.87489,8.8505,17.27209,18.4756a19.19149,19.19149,0,0,1,1.17955,8.78752c-1.21247,9.63154-6.35857,80.23149-8.42,82.69287-.535.63886.85484,1.74863,1.43073,2.57722.82558,1.18926-1.79827,2.21581-2.20919,3.00165-.28007.5354-1.0033.7851-2.27655.7851C391.329,473.338,334.08844,486.32076,332.69147,483.71052Zm.65837-.099Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M372.74993,444.19013c1.78814,1.12254-1.71154,3.82284-3.82284,3.82284a3.82284,3.82284,0,0,1-3.82284-3.82284c0-2.1113,2.36863-7.12837,3.345-5.25641C368.71581,439.44483,370.4166,442.72533,372.74993,444.19013Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2552e3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M378.962,444.19013c1.78814,1.12254-1.71154,3.82284-3.82284,3.82284a3.82284,3.82284,0,0,1-3.82284-3.82284c0-2.1113,2.36862-7.12837,3.345-5.25641C374.92793,439.44483,376.62872,442.72533,378.962,444.19013Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2552e3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M375.99311,443.33216c-2.02256-.60562.63131-4.14065,2.66631-4.70309a3.82284,3.82284,0,0,1,4.70309,2.66631c.56244,2.035-.38406,7.50177-1.82382,5.95755C381.14559,446.83131,378.63235,444.12244,375.99311,443.33216Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2552e3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M399.98768,444.19013c1.78814,1.12254-1.71154,3.82284-3.82284,3.82284a3.82284,3.82284,0,0,1-3.82284-3.82284c0-2.1113,2.36863-7.12837,3.345-5.25641C395.95356,439.44483,397.65435,442.72533,399.98768,444.19013Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2552e3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M406.1998,444.19013c1.78814,1.12254-1.71154,3.82284-3.82284,3.82284a3.82284,3.82284,0,0,1-3.82284-3.82284c0-2.1113,2.36863-7.12837,3.345-5.25641C402.16568,439.44483,403.86647,442.72533,406.1998,444.19013Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2552e3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M403.23087,443.33216c-2.02256-.60562.6313-4.14065,2.66631-4.70309a3.82284,3.82284,0,0,1,4.70308,2.66631c.56245,2.035-.38406,7.50177-1.82382,5.95755C408.38334,446.83131,405.8701,444.12244,403.23087,443.33216Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2552e3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M359.26818,443.33216c-2.02256-.60562.63131-4.14065,2.66631-4.70309a3.82285,3.82285,0,0,1,4.70309,2.66631c.56244,2.035-.38407,7.50177-1.82383,5.95755C364.42065,446.83131,361.90741,444.12244,359.26818,443.33216Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2552e3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M386.45353,447.41774c-.85494,1.93044-4.02852-1.14654-4.33083-3.23609a3.82285,3.82285,0,0,1,3.23608-4.33082c2.08955-.3023,7.39407,1.32355,5.6812,2.55789C390.57231,442.74573,387.56914,444.8987,386.45353,447.41774Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2552e3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M393.78282,441.01582c.50912-2.049,4.1659.43443,4.82412,2.4405a3.82283,3.82283,0,0,1-2.44049,4.82413c-2.00607.65822-7.51154-.02822-6.03727-1.53953C390.5317,446.32829,393.11846,443.68954,393.78282,441.01582Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2552e3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M390.91568,438.14869c.50913-2.049,4.16591.43443,4.82413,2.4405a3.82284,3.82284,0,0,1-2.4405,4.82413c-2.00607.65822-7.51153-.02822-6.03726-1.53953C387.66457,443.46116,390.25133,440.82241,390.91568,438.14869Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2552e3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M354.55713,457.31388l4.49063,14.64225A11.04528,11.04528,0,0,0,369.9059,480.985h31.77364a11.00537,11.00537,0,0,0,10.89618-9.24632l.0105-.04806,3.97847-14.57692a10.31316,10.31316,0,0,0-10.17962-11.96785H364.702a10.31286,10.31286,0,0,0-10.14486,12.168Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#ccc"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M382.7512,430.47527l27.54918-6.986,4.28225,14.17475s-29.6387,2.19475-30.7466,2.205a7.08928,7.08928,0,1,1-1.08483-9.39374Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#ffb6b6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M401.13563,366.19528c19.64289,10.49658,22.25123,33.89629,34.30263,54.46057,1.05357,9.50945-.29657,17.86606-9.86271,18.03485l-4.49681,1.04742-3.27163-.86843-1.72837,1.86843-3.66113-1.74425-4.228.80933-8.76532.202,5.53025-15.31848,7.88562-4.48037-9.321-22.54826Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#3f3d56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M341.10543,327.83955c3.205-4.16844.93515-10.13155.8318-15.41479-.19291-9.85838,8.51495-18.53482,17.97146-19.818,9.45649-1.28315,18.88411,3.6707,25.11531,11.01747,6.1083,7.202,10.69108,10.97678,13.99785,19.96052,1.10888,3.01251,1.07709,11.58777.69243,14.81229-.38461,3.22455-2.82452,6.47172-5.953,6.49711a3.53187,3.53187,0,0,1-4.67514,4.17124c-5.44544-2.37391-16.576-1.6929-16.576-1.6929q-14.80718-2.43723-29.61431-4.87439c-2.52936-.41633-5.15-.86684-7.08485-2.74905a5.10846,5.10846,0,0,1-1.62164-3.95035C334.44592,331.97908,338.89575,330.71353,341.10543,327.83955Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 195.99375,
    cy: 42.51433,
    r: 19.53662,
    fill: "#ffb6b6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M385.45619,323.09658l-25.56043-6.18881a4.34271,4.34271,0,0,1-3.249-5.11433,18.85236,18.85236,0,0,1,22.50909-14.34119l7.56945,1.69519A19.003,19.003,0,0,1,401.11609,321.844l0,0-.15915.06553a25.00141,25.00141,0,0,1-15.06681,1.28815C385.74561,323.16537,385.60044,323.13153,385.45619,323.09658Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2f2e41"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M360.17961,342.19537l-4.75636-9.71266a4.88352,4.88352,0,0,1-.72974-2.95155c.19077-1.01443,1.38061-1.87956,2.26655-1.34988.82207.4915,8.808-11.17945,9.74206-10.9675.96828.21971,1.57382-1.00112,1.80305-1.9672.86862-3.66069-2.99829-.38694-3.19278-4.14424s-4.72107-1.578-7.68168-3.8996-7.62458-2.61277-10.35571-.02509c-2.025,1.91863-2.626,4.86612-3.03243,7.62594a127.262,127.262,0,0,0-1.35475,19.34454c.01015,1.59015.1508,3.396,1.39127,4.391a5.51836,5.51836,0,0,0,2.33486.902l10.17388,2.22585",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.71096,
    cy: 9.62979,
    r: 9.62771,
    fill: "#2f2e41"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M510.61658,422.66663v85.704a4.12233,4.12233,0,0,0,4.11906,4.11906H641.74013a4.12231,4.12231,0,0,0,4.11906-4.11906v-85.704a4.12431,4.12431,0,0,0-4.11906-4.11451H514.73564A4.12433,4.12433,0,0,0,510.61658,422.66663Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#3f3d56"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M513.596,423.733v83.58039a2.20522,2.20522,0,0,0,2.20141,2.20141H640.6829a2.2052,2.2052,0,0,0,2.20141-2.20141V423.733a2.2062,2.2062,0,0,0-2.20141-2.206H515.79745A2.20622,2.20622,0,0,0,513.596,423.733Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2552e3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M507.9604,525.08517a2.4699,2.4699,0,0,0,1.94347.92983H645.89582a2.5024,2.5024,0,0,0,2.44606-3.01569l-2.111-10.02722a2.50692,2.50692,0,0,0-1.55811-1.81784,2.42475,2.42475,0,0,0-.888-.1675H512.0065a2.42455,2.42455,0,0,0-.888.1675,2.50668,2.50668,0,0,0-1.5581,1.81784l-2.111,10.02722A2.50049,2.50049,0,0,0,507.9604,525.08517Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2f2e41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 638.63043,
    y: 512.79262,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(1103.78438 743.8743) rotate(-180)",
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 630.25345,
    y: 512.79262,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(1087.03042 743.8743) rotate(-180)",
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 621.87647,
    y: 512.79262,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(1070.27645 743.8743) rotate(-180)",
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 613.49949,
    y: 512.79262,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(1053.52249 743.8743) rotate(-180)",
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 605.12251,
    y: 512.79262,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(1036.76853 743.8743) rotate(-180)",
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 596.74552,
    y: 512.79262,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(1020.01456 743.8743) rotate(-180)",
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 588.36854,
    y: 512.79262,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(1003.2606 743.8743) rotate(-180)",
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 579.99156,
    y: 512.79262,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(986.50663 743.8743) rotate(-180)",
    fill: "#3f3d56"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 571.61458,
    y: 512.79262,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(969.75267 743.8743) rotate(-180)",
    fill: "#3f3d56"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 563.2376,
    y: 512.79262,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(952.99871 743.8743) rotate(-180)",
    fill: "#3f3d56"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 554.86062,
    y: 512.79262,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(936.24474 743.8743) rotate(-180)",
    fill: "#3f3d56"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 546.48363,
    y: 512.79262,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(919.49078 743.8743) rotate(-180)",
    fill: "#3f3d56"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 538.10665,
    y: 512.79262,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(902.73682 743.8743) rotate(-180)",
    fill: "#3f3d56"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 529.72967,
    y: 512.79262,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(885.98285 743.8743) rotate(-180)",
    fill: "#3f3d56"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 521.35269,
    y: 512.79262,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(869.22889 743.8743) rotate(-180)",
    fill: "#3f3d56"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 512.97571,
    y: 512.79262,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(852.47492 743.8743) rotate(-180)",
    fill: "#3f3d56"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 638.72942,
    y: 516.98111,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(1103.98235 752.25128) rotate(-180)",
    fill: "#3f3d56"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 630.35244,
    y: 516.98111,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(1087.22839 752.25128) rotate(-180)",
    fill: "#3f3d56"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 621.97546,
    y: 516.98111,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(1070.47442 752.25128) rotate(-180)",
    fill: "#3f3d56"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 613.59847,
    y: 516.98111,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(1053.72046 752.25128) rotate(-180)",
    fill: "#3f3d56"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 605.22149,
    y: 516.98111,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(1036.9665 752.25128) rotate(-180)",
    fill: "#3f3d56"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 596.84451,
    y: 516.98111,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(1020.21253 752.25128) rotate(-180)",
    fill: "#3f3d56"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 588.46753,
    y: 516.98111,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(1003.45857 752.25128) rotate(-180)",
    fill: "#3f3d56"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 580.09055,
    y: 516.98111,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(986.70461 752.25128) rotate(-180)",
    fill: "#3f3d56"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 571.71356,
    y: 516.98111,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(969.95064 752.25128) rotate(-180)",
    fill: "#3f3d56"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 563.33658,
    y: 516.98111,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(953.19668 752.25128) rotate(-180)",
    fill: "#3f3d56"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 554.9596,
    y: 516.98111,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(936.44271 752.25128) rotate(-180)",
    fill: "#3f3d56"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 546.58262,
    y: 516.98111,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(919.68875 752.25128) rotate(-180)",
    fill: "#3f3d56"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 538.20564,
    y: 516.98111,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(902.93479 752.25128) rotate(-180)",
    fill: "#3f3d56"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 529.82866,
    y: 516.98111,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(886.18082 752.25128) rotate(-180)",
    fill: "#3f3d56"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 521.45167,
    y: 516.98111,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(869.42686 752.25128) rotate(-180)",
    fill: "#3f3d56"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 513.07469,
    y: 516.98111,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(852.6729 752.25128) rotate(-180)",
    fill: "#3f3d56"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 569.20047,
    y: 522.0073,
    width: 33.50793,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(994.24389 762.30366) rotate(-180)",
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 400.83839,
    cy: 182.41763,
    r: 30,
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M571.76764,478.54054a2.31921,2.31921,0,0,1-1.12593-.26243,2.289,2.289,0,0,1-1.25438-2.00079L568.893,457.126a2.319,2.319,0,0,1,3.51075-2.04878l18.41422,9.10673a2.31915,2.31915,0,0,1,.101,3.91369L572.9991,478.14224A2.30809,2.30809,0,0,1,571.76764,478.54054Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2552e3"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "512.525 313.828 502.965 309.565 514.88 269.765 528.989 276.057 512.525 313.828",
    fill: "#ffb8b8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M693.03334,591.52887,682.69,586.9061l-1.62212-.72691-2.391,6.34982-17.75559,4.40726a4.23936,4.23936,0,0,0-.47843,8.082l17.64106,6.65548,5.40689-5.13274-1.18064,6.72694,6.64434,2.508,6.59265-23.12065Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2f2e41"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M707.73605,456.1033a9.94786,9.94786,0,0,0,14.7018-4.06676l35.19774,3.29219-8.64118-16.21119-32.09959-.641a10.00177,10.00177,0,0,0-9.15874,17.62672Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#ffb6b6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M743.42638,454.9937l48.70747,5.46057.16784-.21479c.32122-.41056,32.19178-41.20654,37.54651-50.918a29.36218,29.36218,0,0,0,3.40021-19.23115l-.03652-.16163-.12678-.10717a14.90036,14.90036,0,0,0-18.63164-.40855,105.543,105.543,0,0,0-30.45785,37.63525L779.9672,435.435l-36.54082,3.60379Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2552e3"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M852.63873,480.37311l1.407,3.17507c.43877,2.92173,2.14394.015,1.99436,2.493,7.24651,5.96942-12.61684,45.86992-27.54311,44.24582-6.92043,2.17385-15.07737,3.06135-23.60325,3.12118q-1.24228.01053-2.49444-.00329c-.53168-.00575-2.16614-1.98012-2.69987-1.992-1.60416-.03574-2.115,1.86692-3.73047,1.78091-1.27734-.06709-3.62851,1.02128-3.83392-.24333-.44251-2.72435-1.2675-2.10656-2.24183-.1793-.67576,1.3367-2.98084-.27282-4.46108-.432-8.54751-.91926-16.82-2.31941-23.97056-3.75731-2.66249-.5285-5.16539-1.067-7.46887-1.5905-4.36266-.98224-8.01235-1.89963-10.6549-2.59767-2.97657-.7778-4.67178-1.28138-4.67178-1.28138l-21.23394,17.27522-16.45347,35.89848c-1.26644.11466-14.9577-3.49013-14.9577-3.49013a9.87758,9.87758,0,0,1-2.59367-10.77358c.83763-2.50792,6.77086-21.05049,12.97831-37.23969,1.83977-4.80642,3.74439-9.68261,5.70384-14.53391,1.60548-3.98373,3.24084-7.95252,4.89616-11.86644,2.87687-6.7858,16.77757-10.44547,33.14629-12.365.83263-.09473,1.67026-.18946,2.51288-.27921,8.3414-.87752,17.19137-1.33122,25.468-1.54065,4.14328-.10469,8.142-.14458,11.86144-.14957q1.80243,0,3.5051.01h.005c3.06634.01494,5.88838.05983,8.37135.10967.48362.01.95229.02493,1.411.03491h.005c.30912.005.61328.015.91243.01993,5.42965.13962,8.76023.30915,8.76023.30915l-.27323-9.45921,1.82883-2.71638.24929-1.94448v-.005l.02991-.2443.20444-.005,3.58983-.06981,30.17468-.58834,12.85246-.54464Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2f2e41"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "629.09 261.091 625.757 271.013 585.004 262.939 589.924 248.295 629.09 261.091",
    fill: "#ffb8b8"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M799.99168,543.105l-3.61779,10.73618-.56929,1.68391,6.54849,1.77606,6.07646,17.25577a4.23936,4.23936,0,0,0,8.09085-.29262l4.947-18.19422-5.62385-4.89406,6.80875.53531,1.86454-6.85281-23.643-4.36314Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2f2e41"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M780.26834,534.56124c-.462,1.303.902-.48915.40853.80243-1.89879,5.00617-5.43056,13.536-6.12384,14.91385-.27013-.05316-51.51652-7.18291-58.42767-9.19319l10.6552-27.01675,1.19639-3.029,17.651,6.29313,6.04631,5.17028,13.20107,1.69151Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2f2e41"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 635.77561,
    cy: 52.61792,
    r: 24.24417,
    fill: "#ffb6b6"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M721.51452,465.84534c1.78135,1.11828-1.705,3.80833-3.80833,3.80833a3.80833,3.80833,0,0,1-3.80833-3.80833c0-2.10328,2.35964-7.10131,3.33229-5.23645C717.49572,461.11805,719.19005,464.3861,721.51452,465.84534Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2552e3"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M727.70306,465.84534c1.78135,1.11828-1.70505,3.80833-3.80833,3.80833a3.80833,3.80833,0,0,1-3.80833-3.80833c0-2.10328,2.35964-7.10131,3.33229-5.23645C723.68425,461.11805,725.37858,464.3861,727.70306,465.84534Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2552e3"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M724.74539,464.99063c-2.01488-.60333.62892-4.12493,2.65619-4.68524a3.80834,3.80834,0,0,1,4.68524,2.65619c.5603,2.02728-.38261,7.47329-1.81691,5.93494C729.87831,468.4765,727.37461,465.77791,724.74539,464.99063Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2552e3"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M748.64888,465.84534c1.78135,1.11828-1.705,3.80833-3.80833,3.80833a3.80833,3.80833,0,0,1-3.80833-3.80833c0-2.10328,2.35964-7.10131,3.33229-5.23645C744.63008,461.11805,746.3244,464.3861,748.64888,465.84534Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2552e3"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M754.83742,465.84534c1.78135,1.11828-1.705,3.80833-3.80833,3.80833a3.80833,3.80833,0,0,1-3.80833-3.80833c0-2.10328,2.35963-7.10131,3.33229-5.23645C750.81861,461.11805,752.51294,464.3861,754.83742,465.84534Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2552e3"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M751.87975,464.99063c-2.01488-.60333.62891-4.12493,2.65619-4.68524a3.80834,3.80834,0,0,1,4.68524,2.65619c.5603,2.02728-.38261,7.47329-1.81691,5.93494C757.01267,468.4765,754.509,465.77791,751.87975,464.99063Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2552e3"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M708.084,464.99063c-2.01489-.60333.62891-4.12493,2.65619-4.68524a3.80833,3.80833,0,0,1,4.68523,2.65619c.56031,2.02728-.38261,7.47329-1.8169,5.93494C713.21686,468.4765,710.71316,465.77791,708.084,464.99063Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2552e3"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M735.1661,469.0607c-.8517,1.92311-4.01323-1.14219-4.31438-3.2238a3.80832,3.80832,0,0,1,3.22379-4.31438c2.08161-.30116,7.366,1.31852,5.65963,2.54817C739.26925,464.40642,736.27748,466.55123,735.1661,469.0607Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2552e3"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M742.46757,462.68309c.50719-2.04121,4.15009.43277,4.80581,2.43123a3.80833,3.80833,0,0,1-2.43123,4.80582c-1.99846.65572-7.483-.02812-6.01435-1.53369C739.22879,467.97539,741.80574,465.34665,742.46757,462.68309Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2552e3"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M739.61132,459.82684c.50719-2.04121,4.15009.43278,4.80582,2.43123a3.80833,3.80833,0,0,1-2.43124,4.80582c-1.99845.65572-7.483-.02812-6.01435-1.53369C736.37254,465.11914,738.94949,462.4904,739.61132,459.82684Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2552e3"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M721.89518,450.83366c-.8517,1.92312-4.01323-1.14218-4.31438-3.22379a3.80833,3.80833,0,0,1,3.22379-4.31439c2.08162-.30115,7.366,1.31853,5.65963,2.54818C725.99833,446.17939,723.00656,448.3242,721.89518,450.83366Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2552e3"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M703.39078,478.91928l4.47358,14.58667a11.00337,11.00337,0,0,0,10.81693,8.99458h31.653a10.9636,10.9636,0,0,0,10.85481-9.21122l.01046-.04788,3.96337-14.52159a10.274,10.274,0,0,0-10.141-11.92242H713.49713a10.27374,10.27374,0,0,0-10.10635,12.12186Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#e6e6e6"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M807.012,368.27742s17.48621-2.26173,22.81374-.13071c1.89555.75823,3.79118,7.7208,7.346,9.79466q.09654.05633.19273.11133a20.789,20.789,0,0,1,10.50167,18.90348,203.0442,203.0442,0,0,0,3.91989,51.15314q.37787,1.86889.79643,3.78551.49194,2.25189,1.04224,4.57476,1.027,4.33346,2.26777,8.93925c.43109,1.59891-2.10913,5.71754-1.63684,7.37174q.47571,1.66622.98,3.37152c1.0097,3.41406,5.09821,4.45582,6.28851,8.12542a6.85478,6.85478,0,0,1-9.9,6.22314l-61.79328-4.81812,5.87983-9.11462-3.98872-5.48449,2.99154-1.99436,1.49577-5.48449-4.72937-18.474-6.77469-15.52945a24.13356,24.13356,0,0,1,9.60935-30.28741l0,0,7.75959-20.55616Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2552e3"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M762.00367,494.91536a9.94788,9.94788,0,0,1,14.14948-5.69857l25.96242-23.99316,2.98129,18.12691-25.1114,20.0053a10.00177,10.00177,0,0,1-17.98173-8.44045Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#ffb6b6"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M803.1502,486.11466l37.93221-27.99457.127.0016c-.04336-.51949-4.38675-52.10611-7.0581-62.86942a29.3622,29.3622,0,0,0-10.57456-16.4188l-.13663-.09375-.16584.00753a14.90037,14.90037,0,0,0-13.94595,12.36185,105.54305,105.54305,0,0,0,3.23182,48.30785l2.74414,8.8902-17.099,15.47311Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2552e3"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M891.24834,372.51692a21.02534,21.02534,0,0,1-11.55731,8.137,24.17522,24.17522,0,0,1-5.75372.97725,21.75406,21.75406,0,0,0-1.71016-6.39193,17.96019,17.96019,0,0,1-.8875,6.37695,21.37363,21.37363,0,0,1-8.41122-2.2536,18.53468,18.53468,0,0,1-9.917-13.30238c-1.02709-6.63127,1.97942-13.14286,3.06634-19.76412,1.09192-6.62129-.95728-15.00754-7.43895-16.74765-4.93606-1.32623-4.38263-.75284-8.486,2.29353,4.26838,6.31126-11.49731,29.43924-17.94925,27.42246-3.64779-1.14026-5.98308-4.48731-6.736-4.48731-5.07065,8.73527,4.47733,23.45366-5.14545,26.51l.79277-.79277c5.80855-7.14478-6.3321-22.267-.52352-29.41182,1.62042-1.99935,3.34552-4.36766,2.8669-6.89548-.45374-2.40321-4.26793-3.67461-5.3848-1.70021,2.00933-4.602-.95728-10.74461-5.86838-11.92627-4.36267-1.052-4.28291.24431-8.66051.80772a21.72487,21.72487,0,0,0-1.5905-5.48948,17.812,17.812,0,0,1-.65316,5.59419,7.0244,7.0244,0,0,1-4.248-1.53566c-3.56989-2.87688-2.847-8.91979.339-12.21546,3.191-3.29567,7.93258-4.48232,12.45476-5.25017,1.31462-9.15451,26.57247-10.10947,29.9204-.96227,1.426-6.83069,9.97679-10.37566,16.623-8.25665s11.25817,8.32646,13.6863,14.868c2.42814,6.53651,3.10621,13.57163,4.602,20.38236s4.02363,13.74613,9.22891,18.388c5.20528,4.63688,13.6863,6.17255,19.17079,1.86472A15.35275,15.35275,0,0,1,891.24834,372.51692Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2f2e41"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M377.75019,352.78578c-.85494,1.93044-4.02851-1.14654-4.33082-3.23609a3.82285,3.82285,0,0,1,3.23608-4.33082c2.08954-.3023,7.39407,1.32355,5.6812,2.55789C381.869,348.11377,378.86581,350.26675,377.75019,352.78578Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#2552e3"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M379.37513,362.52468l3.03016,29.41017,14.21143,3.11683s-7.75483-34.218-8.18293-35.23992a7.08928,7.08928,0,1,0-9.05866,2.71292Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#ffb6b6"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M343.70822,367.1398c-6.21863,1.83587,16.57555,47.59409,48.39024,54.52111a16.2482,16.2482,0,0,0,10.30491-21.69541l-9.37227-21.9201L379.604,385.09219l.78812,10.47244-10.53633-11.74874-21.702-9.88219Z",
    transform: "translate(-177.66498 -284.22403)",
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovieNight);
export default __webpack_public_path__ + "static/media/Movie_Night.bbcb67e9a3493bd64ebcf84e439de82d.svg";
export { ForwardRef as ReactComponent };